// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template/src/index.tsx

import baseIcon, { navigationDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
var NavigationIconAtmWithdrawalPath = 'M27.021 3H2.98v12.823h4.418v9.173c0 1.107.897 2.004 2.004 2.004h11.22a2.004 2.004 0 0 0 2.004-2.004v-9.173h4.396V3ZM7.398 10.614v2.805H5.383V5.404h19.234v8.015h-1.992v-2.805h1.269V8.209H6.263v2.405h1.134Zm6.48 0h6.343v13.982H9.802V10.614h1.67v13.978h2.404V10.614Zm4.817 10.38a1.202 1.202 0 1 1-2.404 0 1.202 1.202 0 0 1 2.404 0Zm-1.202-1.202a1.202 1.202 0 1 0 0-2.405 1.202 1.202 0 0 0 0 2.405Z';
var NavigationIconAtmWithdrawal = baseIcon('NavigationIconAtmWithdrawal', {
  getPath: () => NavigationIconAtmWithdrawalPath,
  defaultStyleSheetGetter: navigationDefaultStyleSheetGetter,
  groupProps: defaultNavigationIconGroupProps,
  shapeSize: defaultNavigationIconShapeSize
});
export default NavigationIconAtmWithdrawal;
//# sourceMappingURL=index.js.map